import { API } from "../utils";

export const getCategoriesAPI = async () => {
  const response = await API.get("GetCategories");
  return response.data;
};
